import React from 'react';
import cn from 'classnames';
import BaseButton from '../buttons/BaseButton';

const ToggleButton = ({ active, onClick, id }) => {
  const btnClassName = cn('toggle-button', { active });
  return (
    <BaseButton
      id={id}
      onClick={onClick}
      className={btnClassName}
      icon='search'
      fillMode='outline'
      themeColor='secondary'
    >
      <span className='title'>Search</span>
    </BaseButton>
  );
};

export default ToggleButton;
